export default __webpack_public_path__ + "static/joanna-74e73cae0d0c233b0be212ae09376ff8.jpg";